export default __webpack_public_path__ + "static/media/plug.562654c8.png";